import { jsx } from 'react/jsx-runtime';
import { UserButton } from './UserButton/index.js';
import { SCNavbarContainer, SCHeaderButton } from './styles.js';
const Navbar = () => {
  return /* @__PURE__ */jsx(SCNavbarContainer, {
    children: /* @__PURE__ */jsx(SCHeaderButton, {
      children: /* @__PURE__ */jsx(UserButton, {})
    })
  });
};
export { Navbar };